import React from 'react';

const Services = ({ services, loading }) => {
  const defaultServices = [
    { name: 'Income Tax Software', description: 'Complete tax filing and compliance solution.', icon: '📄' },
    { name: 'Project Report Software', description: 'Detailed project reports for funding and analysis.', icon: '📊' },
    { name: 'Net Worth Certificate', description: 'Generate professional net worth certificates instantly.', icon: '📜' },
    { name: 'GST Compliance Suite', description: 'Automated GST filing, reconciliation, and compliance.', icon: '🏛️' },
    { name: 'Audit Management', description: 'Complete audit trail and management for professionals.', icon: '🔍' },
    { name: 'Tax Planning Tools', description: 'Advanced tax planning and optimization for clients.', icon: '📈' }
  ];

  const displayServices = services.length > 0 ? services : defaultServices;

  return (
    <section id="services" className="services">
      <h2 className="section-title">Our <span className="highlight">Services</span></h2>
      <div className="services-grid">
        {loading ? (
          <p className="loading-text">Loading services...</p>
        ) : (
          displayServices.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-name">{service.name}</h3>
              <p className="service-desc">{service.description}</p>
              {service.price > 0 && (
                <span className="service-price">₹{service.price}/mo</span>
              )}
              <button className="btn btn-service">Learn More</button>
            </div>
          ))
        )}
      </div>
    </section>
  );
};

export default Services;